import { Autocomplete, Box, Stack, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from '../../../../../redux/store';
import { filterFacCatType, getFullCategoryList, getFullFacilityList, getFullTypeList } from './TicketHelper';

TicketFacCatTypeSelect.propTypes = {
  selectedCategory: PropTypes.object,
  selectedFacility: PropTypes.object,
  selectedTicketType: PropTypes.object,
  setSelectedCategory: PropTypes.func,
  setSelectedTicketType: PropTypes.func,
  setSelectedFacility: PropTypes.func,
  isTestTicket: PropTypes.bool,
  facilities: PropTypes.array,
  ticketTypes: PropTypes.array,
  ticketCategories: PropTypes.array,
  facilityCategories: PropTypes.array,
  filteredCategories: PropTypes.array,
  setFilteredCategories: PropTypes.func,
  setFilteredTypes: PropTypes.func,
  filteredTypes: PropTypes.array,
  facilityTypes: PropTypes.object,
  facilityId: PropTypes.number,
  setConfirmedCategoryFacilityAndType: PropTypes.func,
};

export default function TicketFacCatTypeSelect({
  selectedCategory, setSelectedCategory,
  selectedTicketType, setSelectedTicketType,
  selectedFacility, setSelectedFacility,
  filteredCategories, setFilteredCategories,
  filteredTypes, setFilteredTypes,
  ticketTypes,
  facilities,
  ticketCategories,
  facilityCategories,
  facilityTypes,
  facilityId,
  setConfirmedCategoryFacilityAndType,
  isTestTicket,
}) {
  const { user } = useSelector((state) => state.user);

  const [userClearedFacility, setUserClearedFacility] = useState(false);

  const ticketCategoriesFullList = useMemo(() => getFullCategoryList(ticketCategories, facilityCategories, user), [ticketCategories, facilityCategories, user]);  
  const facilitiesFullList = useMemo(() => getFullFacilityList(facilities), [facilities]);
  const ticketTypesFullList = useMemo(() => getFullTypeList(ticketTypes, facilityTypes, user), [ticketTypes, facilityTypes, user]);

  useEffect(() => {
    filterFacCatType(selectedFacility, facilitiesFullList, facilityCategories, facilityId, facilityTypes, isTestTicket, setFilteredCategories, setFilteredTypes, ticketCategoriesFullList,
      ticketTypesFullList, selectedCategory, selectedTicketType, setSelectedFacility, setSelectedCategory, setSelectedTicketType, setConfirmedCategoryFacilityAndType, userClearedFacility);
  }, [facilitiesFullList, selectedFacility]);

  useEffect(() => {
    if (isTestTicket && ticketTypesFullList?.length) { //reset type list for testing ticket type.
      filterFacCatType(selectedFacility, facilitiesFullList, facilityCategories, facilityId, facilityTypes, isTestTicket, setFilteredCategories, setFilteredTypes, ticketCategoriesFullList,
        ticketTypesFullList, selectedCategory, selectedTicketType, setSelectedFacility, setSelectedCategory, setSelectedTicketType, setConfirmedCategoryFacilityAndType, userClearedFacility);
    }
  }, [isTestTicket, ticketTypesFullList]);

  return <Stack mt={1} spacing={3}>
    {facilitiesFullList.length > 0 && (
      <Autocomplete
        fullWidth
        size="small"
        options={facilitiesFullList}
        value={selectedFacility}
        getOptionLabel={(option) => option.facilityName}
        renderInput={(params) => <TextField {...params} label="Select a facility" autoComplete="off"/>}
        onChange={(event, newValue) => {
          if(!newValue) setUserClearedFacility(true);
          else if (userClearedFacility) setUserClearedFacility(false);
          setSelectedFacility(newValue)
        }}
      />
    )}
    {filteredCategories.length > 0 && <Autocomplete
      fullWidth
      size="small"
      options={filteredCategories}
      value={selectedCategory}
      renderInput={(params) => <TextField {...params} label="Choose a ticket category" autoComplete="off"/>}
      onChange={(event, newValue) => setSelectedCategory(newValue)}
    />}
    {filteredTypes.length > 0 && <Autocomplete
      fullWidth
      size="small"
      options={filteredTypes}
      value={selectedTicketType || null}
      renderOption={(props, option) => (
        <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
          {option.label}
        </Box>
      )}
      renderInput={(params) => <TextField {...params} label="Choose a ticket type" autoComplete="off"/>}
      onChange={(event, newValue) => setSelectedTicketType(newValue)}
    />}
  </Stack>;
}
